export default __webpack_public_path__ + "static/media/dvd.36d7d14a.svg";